module.exports = __webpack_public_path__ + "img/coup.0827bd98.svg";